import { RETURN_METHOD_COMPLAINT, RETURN_METHOD_EXCHANGE, RETURN_METHOD_RESALE, RETURN_METHOD_RETURN, RETURN_METHOD_SERVICE } from "../constants";

// Every item that can still be sent in, shaped as selected-product values. Shared by the
// flows that choose for the customer instead of asking -- withdrawal and the service flows --
// so the returnable filter and the value shape live in one place. The backend marks anything
// already returned, or otherwise ineligible, with returnable === false.
export function preselectReturnableProducts(products, returnMethodType) {
    return (products || [])
        .filter((product) => product?.returnable)
        .map((product) => ({
            productId: product.sessionItemId,
            returnReasons: [],
            returnMethodType,
        }));
}

export function getSelectedReturnMethod(selectedProductValue) {
    if (isComplaintSelected(selectedProductValue)) {
        return RETURN_METHOD_COMPLAINT;
    }
    if (isReturnSelected(selectedProductValue)) {
        return RETURN_METHOD_RETURN;
    }
    if (isExchangeSelected(selectedProductValue)) {
        return RETURN_METHOD_EXCHANGE;
    }
    if (isResaleSelected(selectedProductValue)) {
        return RETURN_METHOD_RESALE;
    }
    if (isServiceSelected(selectedProductValue)) {
        return RETURN_METHOD_SERVICE;
    }

    return null;
}

export function isComplaintSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_COMPLAINT;
}

export function isReturnSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_RETURN;
}

export function isExchangeSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_EXCHANGE;
}

export function isResaleSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_RESALE;
}

export function isServiceSelected(selectedProductValue) {
    return selectedProductValue && selectedProductValue.returnMethodType === RETURN_METHOD_SERVICE;
}

export function getSelectedProductProductId(selectedProductValues) {
    return selectedProductValues.productId;
}
